import  { useContext, useRef, useState } from "react";
import Logo from "../../assets/images/logo.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Preloader from "../../whatsapp/small_component/preloader";
import Swalaleart from "../../whatsapp/function/swalaleart";
import { saveToken } from "../../whatsapp/function/token";
import { useDispatch } from "react-redux";
import { setAccessToken } from "../../redux/tokenslice";

import { GoogleOAuthProvider } from "@react-oauth/google";
import Passwordicon from "../../whatsapp/small_component/passwordicon";
import { ThemeContext } from "../../routing/ApplicationRouting";
import domain from "../../reusecomponent/domain";
import PhoneInput from "react-phone-input-2";

export default function Register() {
  const { data } = useParams();
  const userInformation = useRef({ email: null, name: null });
  try {
    let newdata = JSON.parse(atob(atob(atob(data))));
    if (newdata.email && newdata.name) {
      userInformation.current.email = newdata.email;
      userInformation.current.name = newdata.name;
    } else {
      window.history.back();
    }
  } catch {
    window.history.back();
  }

  const navigate = useNavigate();
  const eye = useRef();
  const [loder, setloder] = useState(false);
  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);

  // OTP verification states
  const [showOtpVerification, setShowOtpVerification] = useState(false);
  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [otpTimer, setOtpTimer] = useState(0);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [otpLoading, setOtpLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);

  // Generate 6-digit OTP
  const generateOTP = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  // Send OTP to mobile number
  const sendOTP = async (mobileNumber, isResend = false) => {
    try {
      if (isResend) {
        setResendLoading(true);
      } else {
        setOtpLoading(true);
      }

      const newOtp = generateOTP();
      setGeneratedOtp(newOtp);

      // Call API to send OTP
      const response = await fetch(`${domain()}/otp_sent`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          mobile_number: mobileNumber,
          otp: newOtp,
        }),
      });

      const result = await response.json();

      if (result.status) {
        if (!isResend) {
          setShowOtpVerification(true);
        }
        setOtpTimer(300); // 5 minutes timer
        startOtpTimer();
        Swalaleart({
          title: "OTP Sent",
          text: `OTP has been sent to ${mobileNumber}`,
          icon: "success",
        });
      } else {
        Swalaleart({
          title: "Error",
          text: result.message || "Failed to send OTP",
          icon: "error",
        });
      }
    } catch (error) {
      Swalaleart({
        title: "Error",
        text: "Network error. Please try again.",
        icon: "error",
      });
    } finally {
      if (isResend) {
        setResendLoading(false);
      } else {
        setOtpLoading(false);
      }
    }
  };

  // Start OTP timer
  const startOtpTimer = () => {
    const timer = setInterval(() => {
      setOtpTimer((prev) => {
        if (prev <= 1) {
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  // Verify OTP
  const verifyOTP = () => {
    if (otp === generatedOtp) {
      setIsOtpVerified(true);
      setShowOtpVerification(false);
      Swalaleart({
        title: "Verified",
        text: "Mobile number verified successfully!",
        icon: "success",
      });
    } else {
      Swalaleart({
        title: "Invalid OTP",
        text: "Please enter the correct OTP",
        icon: "error",
      });
    }
  };

  // Handle mobile number verification
  // const handleMobileVerification = (e) => {
  //   e.preventDefault();
  //   e.stopPropagation();
    
  //   const mobileNumber = String(values.mobile_number || '');
  //   if (!mobileNumber || mobileNumber.length < 7 || mobileNumber.length > 15 || !/^\+?[1-9]\d{6,14}$/.test(mobileNumber)) {
  //     Swalaleart({
  //       title: "Invalid Number",
  //       text: "Please enter valid mobile number with country code",
  //       icon: "error",
  //     });
  //     return;
  //   }
  //   sendOTP(mobileNumber);
  // };

  const handleMobileVerification = (e) => {
  e.preventDefault();
  e.stopPropagation();

  const rawNumber = values.mobile_number; // digits only

  if (!rawNumber || rawNumber.length < 7 || rawNumber.length > 15) {
    Swalaleart({
      title: "Invalid Number",
      text: "Please enter a valid mobile number",
      icon: "error",
    });
    return;
  }


  sendOTP(rawNumber);
};


  // Format timer display
  const formatTimer = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const { values, errors, touched, handleChange, handleBlur, handleSubmit,setFieldValue } =
    useFormik({
      initialValues: {
        name:
          userInformation.current.name !== null
            ? userInformation.current.name
            : "",
        email:
          userInformation.current.email !== null
            ? userInformation.current.email
            : "",
        mobile_number: "",
        businessname: "",
        country: "",
        category: "",
        website_url: "",
        password: "",
      },
      enableReinitialize: true,
      validationSchema: Yup.object({
        name: Yup.string()
          .min(3, "Enter Valid name")
          .required("Please Enter Your Name"),
        email: Yup.string()
          .email("Please Enter Valid Email")
          .required("Please Enter Your Email"),
        mobile_number: Yup.string()
          .matches(/^[1-9]\d{6,14}$/, "Enter a valid mobile number")
          .required("Please Enter Your Mobile Number"),
        businessname: Yup.string()
          .min(5, "Enter Valid Business Name")
          .required("Please Enter Your Name"),
        country: Yup.string().required("Please select a country"),
        category: Yup.string().required("Please select a business category"),
        website_url: Yup.string().url("Enter a valid URL").nullable(),
        password: Yup.string()
          .min(8, "Please Enter Valid Password")
          .required("Please Enter Your Password"),
      }),
      onSubmit: async (values) => {
        // Check if mobile number is verified
        if (!isOtpVerified) {
          Swalaleart({
            title: "Mobile Verification Required",
            text: "Please verify your mobile number before registering",
            icon: "warning",
          });
          return;
        }

        try {
          setloder(true);
          const res = await fetch(`${domain()}/register`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              name: values.name,
              email: values.email,
              mobile_no: values.mobile_number,
              businessname: values.businessname,
              country: values.country,
              category: values.category,
              website_url: values.website_url,
              password: values.password,
            }),
          });
          if (!res.ok) {
            setloder(false);
            Swalaleart({
              title: "Error",
              text: "Internal Server Problem",
              icon: "error",
            });
          }
          const response = await res.json();
          if (response) {
            setloder(false);
            if (response.status) {
              saveToken(response.token);
              dispatch(setAccessToken(response.token));
              Swalaleart({
                title: "Registration Successful",
                text: response.message,
                icon: "success",
                confirmcolor: "#1fee5b",
              });
              navigate("/");
            } else {
              Swalaleart({
                title: "Failed",
                text: response.message,
                icon: "warning",
              });
            }
          }
        } catch (error) {
          setloder(false);
          Swalaleart({ title: "Error", text: "Network Error", icon: "error" });
        }
      },
    });
  const passowrdvisible = () => {
    if (eye.current.type === "password") {
      eye.current.type = "text";
    } else {
      eye.current.type = "password";
    }
  };

  return (
    <GoogleOAuthProvider clientId="818905743654-rgo4fs8bpbt4fj38b5vtq1osgbu4gp9r.apps.googleusercontent.com">
      {/* Theme Loader */}
      <Preloader action={loder} />
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #075E54 0%, #128C7E 50%, #0d9488 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: '20px',
          fontFamily: '"Outfit", "Inter", sans-serif',
        }}
      >
        <style>{`
          .register-form-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 12px;
          }
          .reg-col-half {
            grid-column: span 1;
            width: 100%;
          }
          .reg-col-full {
            grid-column: 1 / -1;
            width: 100%;
          }
          @media (max-width: 768px) {
            .register-outer {
              flex-direction: column !important;
              max-width: 480px !important;
              width: 100% !important;
            }
            .register-brand-panel {
              display: none !important;
            }
            .register-form-panel {
              border-radius: 24px !important;
              padding: 24px 18px !important;
              width: 100% !important;
              box-sizing: border-box !important;
            }
            .register-form-grid {
              display: flex !important;
              flex-direction: column !important;
              gap: 0px !important;
            }
            .reg-col-half,
            .reg-col-full,
            .register-form-grid > div {
              grid-column: 1 / -1 !important;
              width: 100% !important;
            }
          }
        `}</style>

        {/* Outer container for max width and responsive */}
        <div
          className="register-outer"
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            maxWidth: 780,
            minHeight: "auto",
            background: "#fff",
            borderRadius: 24,
            boxShadow: "0 25px 60px rgba(0,0,0,0.3)",
            overflow: "hidden",
            margin: "24px 0",
          }}
        >
          {/* Left brand panel */}
          <div
            className="register-brand-panel"
            style={{
              width: 280,
              minWidth: 260,
              maxWidth: 300,
              background: "linear-gradient(160deg, #075E54 0%, #128C7E 100%)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              padding: "36px 24px",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div style={{ position: 'absolute', top: -40, left: -40, width: 150, height: 150, borderRadius: '50%', background: 'rgba(255,255,255,0.07)' }}/>
            <div style={{ position: 'absolute', bottom: -30, right: -30, width: 110, height: 110, borderRadius: '50%', background: 'rgba(255,255,255,0.05)' }}/>
            <img
              src={Logo}
              alt="logo"
              style={{
                maxWidth: 140,
                width: '70%',
                height: 'auto',
                marginBottom: 24,
                filter: 'brightness(0) invert(1)',
                position: 'relative',
                zIndex: 1,
              }}
            />
            <h3 style={{ color: '#fff', fontWeight: 800, fontSize: 18, textAlign: 'center', marginBottom: 8, position: 'relative', zIndex: 1 }}>Create Account</h3>
            <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 12, textAlign: 'center', lineHeight: 1.6, position: 'relative', zIndex: 1 }}>
              Join thousands of businesses using our WhatsApp CRM to grow smarter.
            </p>
          </div>
          {/* Right form card */}
          <div
            className="register-form-panel"
            style={{
              flex: 1,
              minWidth: 320,
              maxWidth: "100%",
              background: "#fff",
              borderRadius: "0 20px 20px 0",
              boxShadow: "none",
              padding: "28px 24px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div style={{ marginBottom: 28 }}>
              <h2
                style={{
                  fontWeight: 800,
                  fontSize: 22,
                  color: "#1a202c",
                  marginBottom: 4,
                  letterSpacing: '-0.3px',
                }}
              >
                Registration
              </h2>
              <p style={{ color: '#6b7280', fontSize: 12, margin: 0 }}>Fill in your details to get started</p>
            </div>
            <form className="pt-3" onSubmit={handleSubmit} autoComplete="on">
              <div className="register-form-grid">
                {/* Full Name */}
                <div className="form-group mb-3 reg-col-half">
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#f9fafb",
                      color: "#1a202c",
                      fontSize: 12,
                      paddingLeft: 12,
                      paddingRight: 12,
                      boxShadow: "none",
                      width: "100%",
                      cursor: "default",
                      opacity: 1,
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.name}
                    name="name"
                    id="inputname"
                    placeholder="Full Name"
                    disabled
                  />
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.name && touched.name ? errors.name : ""}
                  </div>
                </div>
                {/* Business Name */}
                <div className="form-group mb-3 reg-col-half">
                  <input
                    type="text"
                    className="form-control"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#fff",
                      fontSize: 12,
                      paddingLeft: 12,
                      paddingRight: 12,
                      boxShadow: "none",
                      width: "100%",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.businessname}
                    name="businessname"
                    id="inputbusiness"
                    placeholder="Business Name"
                  />
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.businessname && touched.businessname
                      ? errors.businessname
                      : ""}
                  </div>
                </div>
                {/* Email */}
                <div className="form-group mb-3 reg-col-full">
                  <input
                    type="email"
                    className="form-control"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#f9fafb",
                      color: "#1a202c",
                      fontSize: 12,
                      paddingLeft: 12,
                      paddingRight: 12,
                      boxShadow: "none",
                      width: "100%",
                      cursor: "default",
                      opacity: 1,
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.email}
                    name="email"
                    id="inputemail"
                    placeholder="Email Address"
                    disabled
                  />
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.email && touched.email ? errors.email : ""}
                  </div>
                </div>
                {/* Mobile Number */}
                <div className="form-group mb-3 reg-col-full">
                  <div style={{ display: "flex", gap: 8 }}>

                    <div style={{ flex: 1, minWidth: 0 }}>
                      <PhoneInput
                        country="in"
                        value={values.mobile_number}
                        onChange={(value) => {
                          setFieldValue("mobile_number", value.replace("+",""));
                        }}
                        enableSearch
                        disabled={isOtpVerified}
                        inputStyle={{
                          width: "100%",
                          height: 42,
                          borderRadius: 8,
                          border: "1px solid #dee2e6",
                          fontSize: 12,
                          background: "#fff",
                          boxShadow: "none",
                        }}
                        buttonStyle={{
                          border: "1px solid #dee2e6",
                          borderRadius: "8px 0 0 8px",
                          background: "#fff",
                        }}
                        containerStyle={{ width: "100%" }}
                        dropdownStyle={{
                          borderRadius: 8,
                          fontSize: 14,
                        }}
                      />
                    </div>

                    {!isOtpVerified && (
                      <button
                        type="button"
                        onClick={(e) => handleMobileVerification(e)}
                        disabled={
                          otpLoading ||
                          !values.mobile_number ||
                          values.mobile_number.length < 7 ||
                          values.mobile_number.length > 15
                        }
                        style={{
                          height: 42,
                          padding: "0 12px",
                          borderRadius: 8,
                          border: "none",
                          background: otpLoading ? "#ccc" : "#075E54",
                          color: "#fff",
                          fontSize: 12,
                          fontWeight: 600,
                          cursor: otpLoading ? "not-allowed" : "pointer",
                          whiteSpace: "nowrap",
                          flexShrink: 0,
                        }}
                      >
                        {otpLoading ? "Sending..." : "Verify"}
                      </button>
                    )}

                    {isOtpVerified && (
                      <div
                        style={{
                          height: 42,
                          padding: "0 12px",
                          borderRadius: 8,
                          background: "#28a745",
                          color: "#fff",
                          display: "flex",
                          alignItems: "center",
                          fontSize: 12,
                          fontWeight: 600,
                          flexShrink: 0,
                        }}
                      >
                        ✓ Verified
                      </div>
                    )}
                  </div>

                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.mobile_number && touched.mobile_number
                      ? errors.mobile_number
                      : ""}
                  </div>
                </div>

                {/* Country */}
                <div className="form-group mb-3 reg-col-half">
                  <select
                    className="form-control"
                    name="country"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#fff",
                      fontSize: 12,
                      paddingLeft: 12,
                      color: values.country ? "#222" : "#888",
                      boxShadow: "none",
                      width: "100%",
                    }}
                    value={values.country}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Country</option>
                    <option value="AR">Argentina</option>
                    <option value="BR">Brazil</option>
                    <option value="CL">Chile</option>
                    <option value="CO">Colombia</option>
                    <option value="EG">Egypt</option>
                    <option value="FR">France</option>
                    <option value="DE">Germany</option>
                    <option value="IN">India</option>
                    <option value="ID">Indonesia</option>
                    <option value="IL">Israel</option>
                    <option value="IT">Italy</option>
                    <option value="MY">Malaysia</option>
                    <option value="MX">Mexico</option>
                    <option value="NL">Netherlands</option>
                    <option value="NG">Nigeria</option>
                    <option value="PK">Pakistan</option>
                    <option value="PE">Peru</option>
                    <option value="RU">Russia</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="ZA">South Africa</option>
                    <option value="ES">Spain</option>
                    <option value="TR">Turkey</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="GB">United Kingdom</option>
                    <option value="US">United States</option>
                    <option value="NA">North America</option>
                    <option value="RA">Region A</option>
                    <option value="AP">Asia Pacific</option>
                    <option value="CE">Central Europe</option>
                    <option value="LA">Latin America</option>
                    <option value="ME">Middle East</option>
                    <option value="WE">Western Europe</option>
                    <option value="OTHERS">Others</option>
                  </select>
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.country && touched.country ? errors.country : ""}
                  </div>
                </div>
                {/* Business Category */}
                <div className="form-group mb-3 reg-col-half">
                  <select
                    className="form-control"
                    name="category"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#fff",
                      fontSize: 12,
                      paddingLeft: 12,
                      color: values.category ? "#222" : "#888",
                      boxShadow: "none",
                      width: "100%",
                    }}
                    value={values.category}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  >
                    <option value="">Business Category</option>
                    <option value="ALCOHOL">Alcohol</option>
                    <option value="APPAREL">Apparel</option>
                    <option value="AUTO">Auto</option>
                    <option value="BEAUTY">Beauty</option>
                    <option value="EDU">Education</option>
                    <option value="ENTERTAIN">Entertainment</option>
                    <option value="EVENT_PLAN">Event Planning</option>
                    <option value="FINANCE">Finance</option>
                    <option value="GOVT">Government</option>
                    <option value="GROCERY">Grocery</option>
                    <option value="HEALTH">Health</option>
                    <option value="HOTEL">Hotel</option>
                    <option value="NONPROFIT">Nonprofit</option>
                    <option value="ONLINE_GAMBLING">Online Gambling</option>
                    <option value="OTC_DRUGS">OTC Drugs</option>
                    <option value="OTHER">Other</option>
                    <option value="PHYSICAL_GAMBLING">Physical Gambling</option>
                    <option value="PROF_SERVICES">Professional Services</option>
                    <option value="RESTAURANT">Restaurant</option>
                    <option value="RETAIL">Retail</option>
                    <option value="TRAVEL">Travel</option>
                  </select>
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.category && touched.category ? errors.category : ""}
                  </div>
                </div>
                {/* Website URL (full width) */}
                <div className="form-group mb-3 reg-col-full">
                  <input
                    type="url"
                    className="form-control"
                    style={{
                      height: 42,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#fff",
                      fontSize: 12,
                      paddingLeft: 12,
                      paddingRight: 12,
                      boxShadow: "none",
                      width: "100%",
                    }}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.website_url}
                    name="website_url"
                    id="inputwebsite"
                    placeholder="Website URL (optional)"
                  />
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.website_url && touched.website_url
                      ? errors.website_url
                      : ""}
                  </div>
                </div>
                {/* Password (full width) */}
                <div className="form-group mb-4 reg-col-full">
                  <div
                    className="input-group"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexWrap: "nowrap",
                      padding: 0,
                      borderRadius: 8,
                      border: "1px solid #dee2e6",
                      background: "#fff",
                      overflow: "hidden",
                    }}
                  >
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text text-white"
                        style={{
                          background: '#075E54',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "42px",
                          border: "none",
                          borderRadius: 0,
                          padding: '0 12px',
                        }}
                      >
                        <FontAwesomeIcon icon={faKey} />
                      </span>
                    </div>
                    <input
                      type="password"
                      className="form-control m-0"
                      ref={eye}
                      style={{
                        boxShadow: "none",
                        border: "none",
                        width: "100%",
                        minWidth: 0,
                        flex: 1,
                        background: "transparent",
                        fontSize: 12,
                        paddingLeft: 12,
                        height: 42,
                      }}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      name="password"
                      id="inputpassword"
                      placeholder="Password"
                      autoComplete="new-password"
                    />
                    <div className="input-group-prepend">
                      <span
                        style={{
                          background: '#075E54',
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          height: "42px",
                          border: "none",
                          borderRadius: 0,
                          cursor: "pointer",
                          padding: "0 12px",
                        }}
                      >
                        <Passwordicon passowrdvisible={passowrdvisible} />
                      </span>
                    </div>
                  </div>
                  <div className="invalid-feedback d-block p-0 m-0">
                    {errors.password && touched.password ? errors.password : ""}
                  </div>
                </div>

                <div className="form-group mb-4 reg-col-full">
                    <button
                      type="submit"
                      className="btn-block text-white font-weight-medium text-center"
                      style={{
                        background: "linear-gradient(90deg, #075E54 0%, #128C7E 100%)",
                        border: 'none',
                        borderRadius: 10,
                        height: 42,
                        fontSize: 12,
                        fontWeight: 700,
                        marginBottom: 10,
                        width: "100%",
                        cursor: 'pointer',
                        boxShadow: "0 4px 16px rgba(7,94,84,0.35)",
                        transition: "transform 0.15s, box-shadow 0.15s",
                        letterSpacing: 0.5,
                      }}
                    >
                      Create Account
                    </button>
                </div>
              </div>
            </form>  
            <div
              style={{
                textAlign: "center",
                marginTop: 12,
                color: "#888",
                fontSize: 13,
              }}
            >
              Already have an account?{" "}
              <Link
                to={"/"}
                style={{
                  color: "#075E54",
                  fontWeight: 700,
                  textDecoration: "none",
                }}
              >
                Sign in
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* OTP Verification Modal */}
      {showOtpVerification && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 16,
              padding: "32px",
              maxWidth: 400,
              width: "100%",
              boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
            }}
          >
            <h3
              style={{
                textAlign: "center",
                marginBottom: 8,
                color: "#075E54",
                fontSize: 24,
                fontWeight: 700,
              }}
            >
              Verify Mobile Number
            </h3>
            <p
              style={{
                textAlign: "center",
                color: "#666",
                marginBottom: 24,
                fontSize: 14,
              }}
            >
              Enter the 6-digit OTP sent to {values.mobile_number}
            </p>

            <div style={{ marginBottom: 20 }}>
              <input
                type="text"
                value={otp}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 6);
                  setOtp(value);
                }}
                placeholder="Enter 6-digit OTP"
                style={{
                  width: "100%",
                  height: 52,
                  borderRadius: 8,
                  border: "1px solid #dee2e6",
                  fontSize: 18,
                  textAlign: "center",
                  letterSpacing: 4,
                  fontWeight: 600,
                  paddingLeft: 18,
                  boxShadow: "none",
                }}
                maxLength={6}
              />
            </div>

            {otpTimer > 0 && (
              <div
                style={{
                  textAlign: "center",
                  marginBottom: 16,
                  color: "#666",
                  fontSize: 14,
                }}
              >
                Resend OTP in {formatTimer(otpTimer)}
              </div>
            )}

            <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
              <button
                onClick={verifyOTP}
                disabled={otp.length !== 6}
                style={{
                  flex: 1,
                  height: 48,
                  borderRadius: 8,
                  border: "none",
                  background: otp.length === 6 ? "#075E54" : "#ccc",
                  color: "#fff",
                  fontSize: 16,
                  fontWeight: 600,
                  cursor: otp.length === 6 ? "pointer" : "not-allowed",
                }}
              >
                Verify OTP
              </button>
              {otpTimer === 0 && (
                <button
                  onClick={() => sendOTP(values.mobile_number, true)}
                  disabled={resendLoading}
                  style={{
                    height: 48,
                    padding: "0 20px",
                    borderRadius: 8,
                    border: "1px solid #075E54",
                    background: resendLoading ? "#f8f9fa" : "#fff",
                    color: "#075E54",
                    fontSize: 16,
                    fontWeight: 600,
                    cursor: resendLoading ? "not-allowed" : "pointer",
                  }}
                >
                  {resendLoading ? "Sending..." : "Resend"}
                </button>
              )}
            </div>

            <button
              onClick={() => {
                setShowOtpVerification(false);
                setOtp("");
                setOtpTimer(0);
              }}
              style={{
                width: "100%",
                height: 40,
                borderRadius: 8,
                border: "1px solid #dee2e6",
                background: "#fff",
                color: "#666",
                fontSize: 14,
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </GoogleOAuthProvider>
  );
}
